export default __webpack_public_path__ + "static/media/ripped.4fd367a5.jpg";